/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { QuickToolItem } from "components/quickTools/Primary/QuickToolItem";
import {
  getActiveVerb,
  getQuickToolsVerbs,
  getGroupIndexToShowFlyout,
  getIsFocusOverQuickTools,
  getIsClickedByMouse,
  getComponentPropertyOfCurrentVerb,
  getCurrentVerbDisabledMsg,
  getCurrentVerbOpts,
  getCurrentVerbDisabledTooltipStr,
  getShouldShowConditionalToolTip
} from "selectors/quickToolsSelectors";
import { getCurrentCursor } from "selectors/overlayDropinSelectors";
import {
  cursorType,
  quickToolsVerbIdsForMarkupAnnots,
  VERB_COMMENT_TEXT,
  VERB_COMMENT_REPLACE,
  VERB_COMMENT_INSERT
} from "constants/enums.js";
import { withTheme } from "context/themeContext";
import { shouldSelectVerbOnClick } from "../../utils/QuickToolsUtils";
import { getIsMultiDocModeEnabled } from "selectors/appSelectors";

const mapStoreToProps = (stores, props) => ({
  ...props,
  activeVerb: getActiveVerb(stores),
  quickToolsVerbs: getQuickToolsVerbs(stores),
  flyoutIndex: getGroupIndexToShowFlyout(stores),
  cursorType: getCurrentCursor(stores) || cursorType.DEFAULT,
  forceShowFlyout: getIsFocusOverQuickTools(stores),
  initialAutoHide: getIsClickedByMouse(stores),
  isQuickToolDisabled:
    props.isQuickToolDisabled || getComponentPropertyOfCurrentVerb(stores, props.currentActiveVerb).disable,
  disabledStateNotificationMsg: getCurrentVerbDisabledMsg(
    stores,
    props.disabledStateNotificationMsg,
    props.currentActiveVerb
  ),
  disabledStateOpts: getCurrentVerbOpts(stores, props.currentActiveVerb),
  disabledStateTooltipStr: getCurrentVerbDisabledTooltipStr(stores, props.currentActiveVerb),
  shouldSelectVerbOnClick: shouldSelectVerbOnClick(props.currentActiveVerb, [
    ...quickToolsVerbIdsForMarkupAnnots,
    VERB_COMMENT_TEXT,
    VERB_COMMENT_REPLACE,
    VERB_COMMENT_INSERT
  ]),
  selectedVerbOnUi: stores.quickToolsStore.selectedVerbOnUi,
  isMultiDocModeEnabled: getIsMultiDocModeEnabled(stores),
  shouldShowConditionalToolTip: getShouldShowConditionalToolTip(stores)
});

const QuickToolItemContainer = inject(mapStoreToProps)(withTheme(QuickToolItem));

export { QuickToolItemContainer };
